export const name = 'sdkStateService' as const
